export function getDescription(type: string, profile: { first_name: string }) {
  switch (type) {
    case 'ENTP':
      return `As an ENTP, ${profile.first_name} tends to be expressive, curious, and spontaneous. ${profile.first_name} generally enjoys debating and thinking about issues from different perspectives.`
    case 'ENTJ':
      return `As an ENTJ, ${profile.first_name} tends to be charismatic, direct, and logical. ${profile.first_name} likely enjoys taking charge, working to achieve goals, and encouraging growth from others.`
    case 'ENFP':
      return `As an ENFP, ${profile.first_name} tends to be energetic, adaptable, and inventive. ${profile.first_name} generally likes to think up new, creative ideas and share them with other people.`
    case 'ENFJ':
      return `As an ENFJ, ${profile.first_name} tends to be warm, genuine, and empathetic. ${profile.first_name} is generally persuasive and often helps guide people toward a better life.`
    case 'ESTP':
      return `As an ESTP, ${profile.first_name} tends to be exciting, energetic, and bold. ${profile.first_name} is usually the life of the party and can sometimes make decisions too quickly.`
    case 'ESTJ':
      return `As an ESTJ, ${profile.first_name} tends to be organized, loyal, and hard-working. ${profile.first_name} is likely very principled and thrives when helping and encouraging others to follow a set of beliefs and values.`
    case 'ESFP':
      return `As an ESFP, ${profile.first_name} tends to be friendly, opportunistic, and supportive. ${profile.first_name} usually likes to go with the flow of things. When attending parties, ${profile.first_name} is often the center of attention.`
    case 'ESFJ':
      return `As an ESFJ, ${profile.first_name} tends to be empathetic, warm-hearted, and supportive. ${profile.first_name} is often a social butterfly and highly aware of others’ needs.`
    case 'INTP':
      return `As an INTP, ${profile.first_name} tends to be extremely analytical, objective, and logical. ${profile.first_name} is likely to approach interactions with others in a logical way, rather than relying on emotion.`
    case 'INTJ':
      return `As an INTJ, ${profile.first_name} tends to be confident, analytical, and ambitious. ${profile.first_name} is likely an independent thinker focused on solving the world’s problems.`
    case 'INFP':
      return `As an INFP, ${profile.first_name} tends to be reserved, idealistic, and adaptable. ${profile.first_name} generally enjoys being alone or with small groups of people and likely prefers to listen to and contemplate while in discussions.`
    case 'INFJ':
      return `As an INFJ, ${profile.first_name} tends to be determined, reserved, and altruistic. ${profile.first_name} is likely an idealist and is passionate about making the world a better place and close relationships.`
    case 'ISTP':
      return `As an ISTP, ${profile.first_name} tends to be curious, pragmatic, and confident. ${profile.first_name} is likely unpredictable and spontaneous, but often quiet, preferring to think and process information internally.`
    case 'ISTJ':
      return `As an ISTJ, ${profile.first_name} tends to be reserved, orderly, and practical. ${profile.first_name} is likely self-sufficient, hardworking to meet obligations, and prefers to be alone or in small groups of close friends.`
    case 'ISFP':
      return `As an ISFP, ${profile.first_name} tends to be creative, unconventional, and empathetic. ${profile.first_name} generally has a strong grasp of their senses and often has very vivid memories.`
    case 'ISFJ':
      return `As an ISFJ, ${profile.first_name} tends to be humble, hard-working, and enthusiastic. ${profile.first_name} often focuses on making sure a job is done perfectly and likes to follow a specific approach.`
    default:
      return ''
  }
}

export function getDescriptionGeneric(type: string) {
  switch (type) {
    case 'ENTP':
      return 'As an ENTP, you tend to be expressive, curious, and spontaneous. You generally enjoy debating and thinking about issues from different perspectives.'
    case 'ENTJ':
      return 'As an ENTJ, you tend to be charismatic, direct, and logical. You likely enjoy taking charge, working to achieve goals, and encouraging growth from others.'
    case 'ENFP':
      return 'As an ENFP, you tend to be energetic, adaptable, and inventive. You generally like to think up new, creative ideas and share them with other people.'
    case 'ENFJ':
      return 'As an ENFJ, you tend to be warm, genuine, and empathetic. You are generally persuasive and often help guide people toward a better life.'
    case 'ESTP':
      return 'As an ESTP, you tend to be exciting, energetic, and bold. You are usually the life of the party and can sometimes make decisions too quickly.'
    case 'ESTJ':
      return 'As an ESTJ, you tend to be organized, loyal, and hard-working. You are likely very principled and thrive when helping and encouraging others to follow a set of beliefs and values.'
    case 'ESFP':
      return 'As an ESFP, you tend to be friendly, opportunistic, and supportive. You usually like to go with the flow of things. When attending parties, you are often the center of attention.'
    case 'ESFJ':
      return 'As an ESFJ, you tend to be empathetic, warm-hearted, and supportive. You are often a social butterfly and highly aware of others’ needs.'
    case 'INTP':
      return 'As an INTP, you tend to be extremely analytical, objective, and logical. You are likely to approach interactions with others in a logical way, rather than relying on emotion.'
    case 'INTJ':
      return 'As an INTJ, you tend to be confident, analytical, and ambitious. You are likely an independent thinker focused on solving the worlds’ problems.'
    case 'INFP':
      return 'As an INFP, you tend to be reserved, idealistic, and adaptable. You generally enjoy being alone or with small groups of people and likely prefer to listen to and contemplate while in discussions.'
    case 'INFJ':
      return 'As an INFJ, you tend to be determined, reserved, and altruistic. You are likely an idealist and are passionate about making the world a better place and having close relationships.'
    case 'ISTP':
      return 'As an ISTP, you tend to be curious, pragmatic, and confident. You are likely unpredictable and spontaneous, but often quiet, preferring to think and process information internally.'
    case 'ISTJ':
      return 'As an ISTJ, you tend to be reserved, orderly, and practical. You are likely self-sufficient, hardworking to meet obligations, and prefer to be alone or in small groups of close friends.'
    case 'ISFP':
      return 'As an ISFP, you tend to be creative, unconventional, and empathetic. You generally have a strong grasp of your senses and often have very vivid memories.'
    case 'ISFJ':
      return 'As an ISFJ, you tend to be humble, hard-working, and enthusiastic. You often focus on making sure a job is done perfectly and like to follow a specific approach.'
    default:
      return ''
  }
}

export function getDescriptionForGroup(type: string) {
  switch (type) {
    case 'ENTP':
      return 'People with an <ENTP type> tend to be expressive, curious, and spontaneous. They generally enjoy debating and thinking about issues from different perspectives.'
    case 'ENTJ':
      return 'People with an <ENTJ type> tend to be charismatic, direct, and logical. They likely enjoy taking charge, working to achieve goals, and encouraging growth from others.'
    case 'ENFP':
      return 'People with an <ENFP type> tend to be energetic, adaptable, and inventive. They generally like to think up new, creative ideas and share them with other people.'
    case 'ENFJ':
      return 'People with an <ENFJ type> tend to be warm, genuine, and empathetic. They are generally persuasive and often help guide people toward a better life.'
    case 'ESTP':
      return 'People with an <ESTP type> tend to be exciting, energetic, and bold. They are usually the life of the party and can sometimes make decisions too quickly.'
    case 'ESTJ':
      return 'People with an <ESTJ type> tend to be organized, loyal, and hard-working. They are likely very principled and thrive when helping and encouraging others to follow a set of beliefs and values.'
    case 'ESFP':
      return 'People with an <ESFP type> tend to be friendly, opportunistic, and supportive. They usually like to go with the flow of things. When attending parties, they are often the center of attention.'
    case 'ESFJ':
      return 'People with an <ESFJ type> tend to be empathetic, warm-hearted, and supportive. They are often social butterflies and highly aware of others’ needs.'
    case 'INTP':
      return 'People with an <INTP type> tend to be extremely analytical, objective, and logical. They are likely to approach interactions with others in a logical way, rather than relying on emotion.'
    case 'INTJ':
      return 'People with an <INTJ type> tend to be confident, analytical, and ambitious. They are likely an independent thinker focused on solving the worlds’ problems.'
    case 'INFP':
      return 'People with an <INFP type> tend to be reserved, idealistic, and adaptable. They generally enjoy being alone or with small groups of people and likely prefer to listen to and contemplate while in discussions.'
    case 'INFJ':
      return 'People with an <INFJ type> tend to be determined, reserved, and altruistic. They are likely idealists and are passionate about making the world a better place and having close relationships.'
    case 'ISTP':
      return 'People with an <ISTP type> tend to be curious, pragmatic, and confident. They are likely unpredictable and spontaneous, but often quiet, preferring to think and process information internally.'
    case 'ISTJ':
      return 'People with an <ISTJ type> tend to be reserved, orderly, and practical. They are likely self-sufficient, hardworking to meet obligations, and prefer to be alone or in small groups of close friends.'
    case 'ISFP':
      return 'People with an <ISFP type> tend to be creative, unconventional, and empathetic. They generally have a strong grasp of their senses and often have very vivid memories.'
    case 'ISFJ':
      return 'People with an <ISFJ type> tend to be humble, hard-working, and enthusiastic. They often focus on making sure a job is done perfectly and like to follow a specific approach.'
    default:
      return ''
  }
}

type MyersBriggsAnswers = Record<string, number>

export function assessmentQuestions() {
  return [
    { left: 'makes lists', right: 'relies on memory' },
    { left: 'skeptical', right: 'wants to believe' },
    { left: 'bored by time alone', right: 'needs time alone' },
    {
      left: 'accepts things the way they are',
      right: 'unsatisfied with the ways things are',
    },
    { left: 'keeps a clean room', right: 'just puts stuff where ever' },
    {
      left: 'thinks "robotic" is an insult',
      right: 'strives to have a mechanical mind',
    },
    { left: 'energetic', right: 'mellow' },
    { left: 'prefer multiple choice tests', right: 'prefer essay answers' },
    { left: 'chaotic', right: 'organized' },
    { left: 'easily hurt', right: 'thick-skinned' },
    { left: 'works best in groups', right: 'works best alone' },
    { left: 'focused on the present', right: 'focused on the future' },
    { left: 'plans far ahead', right: 'plans at the last minute' },
    { left: "wants people's respect", right: 'wants their love' },
    { left: 'gets worn out by parties', right: 'gets fired up by parties' },
    { left: 'fits in', right: 'stands out' },
    { left: 'keeps options open', right: 'commits' },
    {
      left: 'wants to be good at fixing things',
      right: 'wants to be good at fixing people',
    },
    { left: 'talks more', right: 'listens more' },
    {
      left: 'when describing an event, will tell people what happened',
      right: 'when describing an event, will tell people what it meant',
    },
    { left: 'gets work done right away', right: 'procrastinates' },
    { left: 'follows the heart', right: 'follows the head' },
    { left: 'stays at home', right: 'goes out on the town' },
    { left: 'wants the big picture', right: 'wants the details' },
    { left: 'improvises', right: 'prepares' },
    {
      left: 'bases morality on justice',
      right: 'bases morality on compassion',
    },
    {
      left: 'finds it difficult to yell very loudly when others are far away',
      right: 'yelling to others when they are far away comes naturally',
    },
    { left: 'theoretical', right: 'empirical' },
    { left: 'works hard', right: 'plays hard' },
    { left: 'uncomfortable with emotions', right: 'values emotions' },
    {
      left: 'likes to perform in front of other people',
      right: 'avoids public speaking',
    },
    {
      left: 'likes to know "who?", "what?", "when?"',
      right: 'likes to know "why?"',
    },
  ]
}

function getScore(
  answers: Record<string, number>,
  initial: number,
  answerKeys: {
    add: Array<number>
    subtract: Array<number>
  },
) {
  const { add, subtract } = answerKeys

  const added = add
    .map(key => answers[String(key)])
    .reduce((total, curr) => total + curr, initial)

  return subtract
    .map(key => answers[String(key)])
    .reduce((total, curr) => total - curr, added)
}

function getTypeScores(answers: MyersBriggsAnswers): MyersBriggsAnswers {
  const typeScores: Record<string, number> = {}

  typeScores['IE'] = getScore(answers, 30, {
    add: [14, 22, 26],
    subtract: [2, 6, 10, 18, 30],
  })
  typeScores['SN'] = getScore(answers, 12, {
    add: [3, 7, 11, 15, 19, 31],
    subtract: [23, 27],
  })
  typeScores['FT'] = getScore(answers, 30, {
    add: [5, 9, 21],
    subtract: [1, 13, 17, 25, 29],
  })
  typeScores['JP'] = getScore(answers, 18, {
    add: [0, 4, 12, 20, 28],
    subtract: [8, 16, 24],
  })

  return typeScores
}

export function getType(answers: MyersBriggsAnswers): string {
  const scores = getTypeScores(answers)
  let type = ''

  type += scores['IE'] > 24 ? 'E' : 'I'
  type += scores['SN'] > 24 ? 'N' : 'S'
  type += scores['FT'] > 24 ? 'T' : 'F'
  type += scores['JP'] > 24 ? 'P' : 'J'

  return type
}

export function getTitle(type: string) {
  switch (type) {
    case 'ENTP':
      return 'Debater'
    case 'ENTJ':
      return 'Visionary'
    case 'ENFP':
      return 'Encourager'
    case 'ENFJ':
      return 'Advocate'
    case 'ESTP':
      return 'Explorer'
    case 'ESTJ':
      return 'Commander'
    case 'ESFP':
      return 'Entertainer'
    case 'ESFJ':
      return 'Provider'
    case 'INTP':
      return 'Thinker'
    case 'INTJ':
      return 'Intellectual'
    case 'INFP':
      return 'Empath'
    case 'INFJ':
      return 'Advisor'
    case 'ISTP':
      return 'Detective'
    case 'ISTJ':
      return 'Investigator'
    case 'ISFP':
      return 'Creator'
    case 'ISFJ':
      return 'Guardian'
    default:
      return ''
  }
}
